export default function Django_Admin() {
  return <div>Django_Admin Component</div>;
}
